/* global window */
import React from 'react'
import { Route, Link } from 'react-router-dom'
import DrawingContainer from './containers/drawingContainer'
import DrawingDoneContainer from './containers/drawingDoneContainer'
import DrawingsContainer from './containers/drawingsContainer'
import CanvasContainer from './containers/canvasContainer'
import PromptCanvasContainer from './containers/promptCanvasContainer'
import HomeContainer from './containers/homeContainer'
import SignupContainer from './containers/signupContainer'
import withGATracker from './googleAnalyticsTracker'

class App extends React.Component {
  constructor(props) {
    super(props)

    const subdomain = this.getSubdomain()
    const organization = {}

    if (subdomain === 'quiznos') {
      organization.key = 'quiznos'
      organization.logo =
        'https://firebasestorage.googleapis.com/v0/b/picclescoloring.appspot.com/o/quiznos_logo.png-Mon%20Jul%2002%202018%2020%3A10%3A58%20GMT-0400%20(EDT)?alt=media&token=c63a78bd-390d-4935-b7f5-b1aee5fee0ad'
      organization.primaryColor = '#78a22f'
    } else {
      organization.key = 'app'
      organization.logo =
        'https://static1.squarespace.com/static/56c7b0d8ab48de2d5c683bd1/t/5978f8efd482e958fc1a32e1/favicon.ico'
      organization.primaryColor = '#8acf1f'
    }

    this.state = { organization }
  }

  getSubdomain() {
    return window.location.href.split('/')[2].split('.')[0]
  }

  isWhitelabeled() {
    return this.state.organization.key !== 'app'
  }

  isQuiznos() {
    return this.state.organization.key === 'quiznos'
  }

  render() {
    return (
      <div>
        {this.isWhitelabeled() && (
          <style
            dangerouslySetInnerHTML={{
              __html: `
            button, a.button {
              background-color: ${this.state.organization.primaryColor}
            }

            .header {
              height: 60px;
            }

            .header .logo {
              width: 55px;
            }

            .footer {
              text-align: center;
              font-weight: 600;
              color: #aba9a9;
              font-size: 15px;
              margin-top: 10px;
            }

            .footer a {
              text-decoration:none;
            }

            .footer img {
              width: 20px;
            }
          `,
            }}
          />
        )}
        <div className="header">
          <Link key="drawing-link" to="/">
            <img alt="logo" className="logo" src={this.state.organization.logo} />
          </Link>
        </div>
        <main className="main-container">
          <Route exact path="/" component={withGATracker(HomeContainer)} />
          <Route exact path="/test" component={withGATracker(DrawingContainer)} />
          <Route exact path="/drawings/:id/:index/draw/:drawingSquareId" component={CanvasContainer} />
          <Route exact path="/drawings/:piccleExperienceId/promptDraw/:piccleKey" component={PromptCanvasContainer} />
          <Route exact path="/drawings/:id/:index/signup/:drawingSquare" component={withGATracker(SignupContainer)} />
          <Route exact path="/drawings/:id" component={withGATracker(DrawingContainer)} />
          <Route exact path="/drawings/:id/:index/done" component={withGATracker(DrawingDoneContainer)} />
          <Route exact path="/drawings" component={withGATracker(DrawingsContainer)} />
        </main>
        {this.isWhitelabeled() && (
          <div className="footer">
            Powered by{' '}
            <a href="https://app.piccles.com" style={{ color: '#8acf1f' }} target="_blank" rel="noopener noreferrer">
              Piccles
            </a>
          </div>
        )}
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js